// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lc-1";
export var messageSideRight = "_lc-2";
export var subscribeToBackInStockBubbleContainer = "_lc-0";